import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {getLabel} from '../../../../utils/woundCareUtils'
const valid = measurement => {
  return measurement !== null && measurement !== '' && measurement !== undefined;
}

const WoundCareTableRow = ({
  index,
  readOnly,
  woundCare,
  onClick,
}) => (
  <tr className={classnames('align-top', {'cursor-pointer': !readOnly, 'cursor-default': readOnly}, {'bg-gray-100': index % 2 === 1})} 
      onClick={() => readOnly ? null : onClick(index)} >
    <td className="p-4 align-middle">
      {valid(woundCare.location) && <span>{getLabel("location", woundCare.location)}</span>}
    </td>
    <td className="p-4 align-middle">
      {(valid(woundCare.type) && valid(woundCare.stage)) && <span>{getLabel("type", woundCare.type)}/{getLabel("stage", woundCare.stage)}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.cleansedWith) && <span>{getLabel("cleansedWith", woundCare.cleansedWith)}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.packedWith) && <span>{getLabel("packedWith", woundCare.packedWith)}</span>}
    </td>
    <td className="p-4 align-middle">
      {(valid(woundCare.length) && valid(woundCare.width) && valid(woundCare.depth)) && <span>{woundCare.length}/{woundCare.width}/{woundCare.depth}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.coveredWith) && <span>{getLabel("coveredWith", woundCare.coveredWith)}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.drainageType) && <span>{getLabel("drainageType", woundCare.drainageType)}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.securedWith) && <span>{getLabel("securedWith", woundCare.securedWith)}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.malodorous) && <span>{woundCare.malodorous ? "Yes" : "No"}</span>}
    </td>
    <td className="p-4 align-middle">
      {valid(woundCare.tunneling) && <span>{woundCare.tunneling ? "Yes" : "No"}</span>}
    </td>
    {!readOnly && (
      <td className="p-4 text-right align-middle">
        <button id="vitals-edit-button" className="bg-blue-600 text-gray-100 p-3 px-4 rounded-full inline-block" onClick={() => onClick(index)}>
          <i className="fas fa-pencil inline-block mr-1" /> Edit
        </button>
      </td>
    )}
  </tr>
)

WoundCareTableRow.propTypes = {
  index: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  woundCare: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

WoundCareTableRow.defaultProps = {
  readOnly: false,
}

export default WoundCareTableRow
